import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

const LINKS = [["About", "#about"], ["Services", "#services"], ["BMI", "#bmi"], ["Timings", "#clinic"], ["FAQs", "#faq"]];

export const Header = () => (
  <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-100" data-testid="site-header">
    <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
      <a href="#top" className="flex items-center gap-3" data-testid="header-logo">
        <span className="h-10 w-10 rounded-xl bg-[#DC2626] text-white grid place-items-center"><Plus className="h-5 w-5" strokeWidth={3} /></span>
        <span className="leading-tight">
          <span className="block font-display font-bold text-[#1A252C]">Dr. Saurabh Agarwal</span>
          <span className="block text-xs text-muted-foreground">Physician & Diabetologist</span>
        </span>
      </a>
      <nav className="hidden md:flex items-center gap-8 text-sm text-muted-foreground">
        {LINKS.map(([l, h]) => (
          <a key={h} href={h} className="hover:text-primary transition-colors" data-testid={`nav-${l.toLowerCase()}`}>{l}</a>
        ))}
        <Link to="/admin/login" className="hover:text-primary transition-colors" data-testid="nav-staff-login">Staff login</Link>
      </nav>
      <Button asChild className="rounded-full px-5 bg-[#FACC15] text-[#1E1B4B] hover:bg-[#EAB308] font-semibold" data-testid="header-book-btn">
        <a href="#book">Book appointment</a>
      </Button>
    </div>
  </header>
);
